'use strict';

class Analytics {
    constructor () {
        this.helper = require('./helpers/helper');
        this.quickImpressionSender = require('./helpers/quickImpressions');
        this.logName = 'Analytics';

        this.testMode = this.helper.isTestEnabled();
    }
    init (globalContainer, helperContainer) {
        this.globalContainer = globalContainer;
        this.helperContainer = helperContainer;
        this.helperData = this.helperContainer.data();

        if (this.testMode) {
            console.info(this.logName + ' Initialized!');
        }
    }

    log (data, inline = false) {
        if (!this.testMode) {
            return;
        }
        if (inline) {
            console.info(this.logName + ': ' + data);
        } else {
            console.info(this.logName + ': ');
            console.info(data);
        }
    }

    push (pushObject) {
        this.log(pushObject);
        this.helper.push(pushObject, false);
    }

    generateAnalyticsSku (fullPageLoad = false) {
        let sku = $('.analytics.product').length ? $('.analytics.product').data('item_id') : '';
        let color = '';
        let size = '';
        let isPdp = this.helper.checkPage('/product/');
        if (fullPageLoad && isPdp) {
            color = $('.analytics.product').data('variant');
            size = $('.analytics.product').data('size');
        } else {
            color = $('.swatch-circle.selected').data('attr-value');
            size = $('[data-attr="size"] input:checked').attr('id');
        }
        if (color && size) {
            sku = sku + '_' + color + '_' + size;
        } else if (color) {
            sku = sku + '_' + color;
        }
        sku = sku.trim();
        return sku.toUpperCase();
    }
};

module.exports = Analytics;
